export default __webpack_public_path__ + "static/media/Dining-room.fd0bd686.jpg";